import FocusableBackButton from '@components/FocusableBackButton';
import { useDeliveryContext } from '@context/Delivery';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { DELIVERY_BACK } from '@pages/Delivery/focusKey';
import { useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';

import * as styles from './styles';

const DeliveryView = () => {
  const { deliveryText, setButtonFocus, targetUrl } = useDeliveryContext();

  const { focusKey } = useFocusable();

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.rootContainer}>
        <div css={styles.mainContainer}>
          <div css={styles.mainTopContainer}>
            <FocusableBackButton focusKey={DELIVERY_BACK} />
            <div css={styles.title}>{deliveryText.title}</div>
          </div>
          <div css={styles.mainContentContainer}>
            <QRCodeSVG css={styles.qr} value={targetUrl} />
            <div css={styles.rightContainer}>
              <div css={styles.subtitle}>{deliveryText.subtitle}</div>
              {deliveryText.information && (
                <div css={styles.information}>{deliveryText.information}</div>
              )}
              <div css={styles.content}>{deliveryText.description}</div>
            </div>
          </div>
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default DeliveryView;
